import { FC, useEffect, useState } from 'react';
import { CardActionStyled, CardContainer, CardMediaStyled, CardStyled, TypographyStyled, UnauthorizedWrapper } from './Unauthorized.styled';
import Header from '../../SharedComponents/Header/Header';
import { Button, CardContent } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import { getUserUnhandled } from '../../Services/LondunarkerfiAPIService';
import unauthorizedImage from '../../images/Unauthorized.jpg';

const Unauthorized: FC = () => {

  const [errorMessage, setErrorMessage] = useState<string>('Þú hefur ekki aðgang að þessari síðu.');
  const [secondaryErrorMessage, setSecondaryErrorMessage] = useState<string>('Ef þú telur að það sé ekki rétt getur þú haft samband við Fiskistofu.');
  
  useEffect(() => {
    const handleLoginChange = async () => {
      try {
        await getUserUnhandled();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        if (error.response && [401, 403].includes(error.response.status)) {
          // Check if the body of the response contains "Token has expired".
          const responseBody = error.response.data; // Assuming the body is in `data`
          if (responseBody === "Token has expired") {
            setErrorMessage("Auðkenning rann út.");
            setSecondaryErrorMessage("");
          } else {
            setErrorMessage("Auðkenning tókst en þú hefur ekki aðgang að þessu kerfi");
            setSecondaryErrorMessage("Ef þú heldur að það sé ekki rétt getur þú tilkynnt það til Fiskistofu.");
          }
        }
      }
    };
    handleLoginChange();
  }, []);

  const handleMail = () => {
    window.location.href = 'mailto:fiskistofa@fiskistofa.is';
  };

  return (
    <UnauthorizedWrapper>
      <Header isAuthorized={false} />
      <CardContainer>
        <CardStyled>
          <CardMediaStyled
            image={unauthorizedImage}
            title="unauthorized-image"
          />
          <CardContent>
            <TypographyStyled gutterBottom variant="h5">
              {errorMessage}            
            </TypographyStyled>
            <TypographyStyled variant="body2" color="text.secondary">
              {secondaryErrorMessage}
            </TypographyStyled>
          </CardContent>
          <CardActionStyled>
            <Button variant="outlined" endIcon={<MailIcon />} onClick={handleMail}>
              Tilkynna
            </Button>
          </CardActionStyled>
        </CardStyled>
      </CardContainer>
    </UnauthorizedWrapper>
  );
}
export default Unauthorized;
